import React, { ChangeEvent, FunctionComponent, memo } from 'react';
import './CheckBox.scss';

interface CheckBoxProps {
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  labelMargin?: string;
  cirle?: boolean;
  disabled?: boolean;
  classes?: string;
}

const CheckBox: FunctionComponent<CheckBoxProps> = memo(
  ({
    children,
    value,
    onChange = () => {},
    checked,
    labelMargin = '12.2px',
    cirle = false,
    disabled = false,
    classes = '',
  }) => (
    <label
      className={`${'CheckBox'} ${cirle ? 'CheckBox--circle' : ''}`}
      style={disabled ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
    >
      <input
        style={disabled ? { cursor: 'not-allowed' } : { cursor: 'pointer' }}
        type={cirle ? 'radio' : 'checkbox'}
        name={value}
        value={value}
        onChange={(e) => {
          if (disabled) return;
          onChange(e);
        }}
        checked={checked}
        className={classes ? classes : ''}
      />
      <div style={{ marginLeft: labelMargin }}>{children}</div>
    </label>
  )
);

export default CheckBox;
